import React from "react";
import "./Footer.css";
import fb from "../../img/facebook.svg";
import x from "../../img/x.svg";
import yt from "../../img/yt.svg";
import insta from "../../img/insta.svg";
import link from "../../img/link.svg";
import cloud from "../../img/cloud.svg"
import tiktok from "../../img/tiktok.svg"

export default class Footer extends React.Component{

    componentDidMount() {
        if (window.innerWidth < 1100 && window.location.href.includes("payment")){
            document.querySelector("footer").style.display = "none"
            document.querySelector(".mobile-menu").style.display = "none"
        }
    }

    render() {
        return (
            <footer>
                <div className="social">
                    <a href="https://www.facebook.com/SavetheChildrenMexico">
                        <img src={fb} alt=""/>
                    </a>
                    <a href="https://twitter.com/savechildrenmx">
                        <img src={x} alt=""/>
                    </a>
                    <a href="https://www.youtube.com/user/SavetheChildrenMex">
                        <img src={yt} alt=""/>
                    </a>
                    <a href="https://www.instagram.com/savethechildren_mx">
                        <img src={insta} alt=""/>
                    </a>
                    <a href="https://www.linkedin.com/company/savethechildrenmexico/">
                        <img src={link} alt=""/>
                    </a>
                    <a href="https://soundcloud.com/save-the-children-mx">
                        <img src={cloud} alt=""/>
                    </a>
                    <a href="https://www.tiktok.com/@savethechildrenmx">
                        <img src={tiktok} alt=""/>
                    </a>
                </div>
                <div className="adress">
                    <p>Contacto Save the Children:</p>
                    <p>Av. Francisco Sosa 26 | Villa Coyoacán, 04000 | Ciudad de México | 800 800 0085</p>
                    <p>mail: atencion.donantes@savethechildren.org</p>
                    <p>Aviso de Privacidad para Ley Anti-Lavado | Aviso de Privacidad</p>
                </div>
            </footer>
        );
    }
}